// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const operatorCapabilityId = (z.number());
export const operatorCapability = z.object({
    id: operatorCapabilityId,
    operator_id: operatorId,
    capability: z.string(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const operatorCapabilityInitializer = z.object({
    id: operatorCapabilityId.optional(),
    operator_id: operatorId,
    capability: z.string(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const operatorCapabilityMutator = z.object({
    id: operatorCapabilityId.optional(),
    operator_id: operatorId.optional(),
    capability: z.string().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=OperatorCapability.js.map